import { POST,postFile } from "../../index";

export const getDictType = (param) => POST("/v1/dict/getDictType", param);
export const addDictType = (param) => POST("/v1/dict/addDictType", param);
export const updateDictType = (param) => POST("/v1/dict/updateDictType", param);
export const deleteDictType = (param) => POST("/v1/dict/deleteDictType", param);
export const refreshData = (param) => POST("/v1/dict/refreshData", param);

export const getDictValue = (param) => POST("/v1/dict/getDictValue", param);
export const addDictValue = (param) => POST("/v1/dict/addDictValue", param);
export const updateDictValue = (param) => POST("/v1/dict/updateDictValue", param);
export const deleteDictValue = (param) => POST("/v1/dict/deleteDictValue", param);

export const selectRepairType = (param) => POST("/v1/dict/selectRepairType", param);
export const selectMalfunctionType = (param) => POST("/v1/dict/selectMalfunctionType", param);

export const selectExternalType = (param) => POST("/v1/dict/selectExternalType", param);
export const selectHomePageUrl = (param) => POST("/v1/dict/selectHomePageUrl", param);

export const selectCarOperationType = (param) => POST("/v1/dict/selectCarOperationType", param);